import moment from 'moment-timezone';
import React from 'react';
import { ValidDateFormats } from '../../Shared/DateUtilities';
import styles from './EditMedicationInfoHeader.module.css';
import { ProfileIcon } from '../../Components/Icons';
export function EditMedicationInfoHeader(props) {
    var updatedOnMoment = moment.utc(props.updatedOn).local();
    var updatedOn = updatedOnMoment.format(ValidDateFormats.PrettyPrintFullDateTimeWithBullet) + " by " + props.updatedBy;
    return (React.createElement("div", { className: styles.toolbar },
        React.createElement("div", { className: styles.datestamp, title: updatedOn, onClick: props.onClick },
            React.createElement(ProfileIcon, { size: '16', noPadding: true }),
            React.createElement("div", { className: styles.info }, "Last updated: "),
            React.createElement("div", { className: styles.updatedText, "data-test-id": 'last-updated' }, updatedOn))));
}
